import * as React from 'react';
import styled from 'styled-components';
import  jsQR  from  "jsqr" ;
import * as QRCode from "qrcode";
import crypto from 'crypto-js';


type Props = {
    // buttonText: string,
}
export const QrcodeBackUp: React.FC<Props> = (props) => {
  const [qrTagStatus,setQRTagStatus] = React.useState(<p>テストタグ</p>);
 
  // width:256px;
  const QrcodeComponent = styled.div`
    margin:0 auto;
  `;
    
  const imgStyle: React.CSSProperties = {
      display: 'initial',
       
      width:190,
      height:190,
  };
  const canvaStyle: React.CSSProperties = {
      display: 'none',
  };

  React.useEffect(()=>{
    (async() => {
      QRCode.toDataURL(`https://www.sushitop.io/index.html?pkey=${localStorage.getItem('privateKey')}`,function (error,url) {
        console.log(`QRコードを生成しました`);
        console.log(url)
        setQRTagStatus( <img src={url} style={imgStyle}></img>);
      });
      // QRCode.toDataURL(`https://www.sushitop.io/index.html?pkey=${crypto.AES.decrypt(`${localStorage.getItem('privateKeyCrypto')}`, 'nft').toString(crypto.enc.Utf8)}`,function (error,url) {
      //   console.log(`QRコードを生成しました`);
      //   console.log(url)
      //   setQRTagStatus( <img src={url} style={imgStyle}></img>);
      // });
    })()
  },[]);
    
  return (
    <QrcodeComponent id='qrcode'>
      <canvas width="256" height="256" style={canvaStyle}></canvas>
      {qrTagStatus}
    </QrcodeComponent>
  );
};